
<template>
  <div class="card-tags">
    <div v-for="(tag, index) in tags" :key="index" @click="selectTag(index)">
      <div class="card-box" :class="{'selected-tag': index === selected}">
        <div class='card-shadow'></div>

        <div class='card-tag' v-if="$slots[tag]">
          <slot :name="tag"></slot>
        </div>
        <div v-else class='card-tag'>{{tag}}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'card-tags',
  props:{
    selected:{
      type: Number,
      default: 0,
    },
    tags:{
      type: Array,
      default: () => {return []},
    },
  },
  data() {
    return {
      select_tag: 1,
    }
  },
  methods:{
    selectTag(index){
      this.$emit('changeSelect', index)
    },
  },
}
</script>
<style>
  .card-tags{
    width:  650px;
    padding-top: 10px;
    overflow: hidden;
    margin-bottom: -15px;
    z-index: 1;
    position: relative;
  }
  .card-tags>div{
    display: inline-block;
    margin-right: -20px;
    margin-bottom: -2px;
  }
  .card-box{
    width: 176px;
    height: 39px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  /* 边框 */
    .card-shadow, .card-shadow:before ,.card-shadow:after{
      transition: background,box-shadow .5s;
      cursor: pointer;
    }
    .selected-tag .card-shadow{
      background: #99BAFF;
      box-shadow: 0 100px 15px 10px rgba(87, 142, 255, 0.25);
    }
    .selected-tag .card-shadow:before{
      background: #99BAFF;
    }
    .selected-tag .card-shadow:after{
      background: #99BAFF;
    }
    .card-shadow{
      position: absolute;
      z-index: 0;
      width: 88px;
      height: 39px;
      margin: 0 auto;
      background: #FFFFFF;
      box-shadow: 0 1px 15px 8px rgba(0, 0, 0, 0.05);
    }
    .card-shadow:before{
      content:'';
      position: absolute;
      top: 0;
      height: 100%;
      z-index: 2;
      background: #FFFFFF;
      left: -43.9px;
      width: 44px;
      clip-path: path('M 44,0 C 22,0 22,44 0,44 L 44,44 Z');
    }
    .card-shadow:after{
      content:'';
      position: absolute;
      top: 0;
      height: 100%;
      z-index: 2;
      background: #FFFFFF;
      right: -43.9px;
      width: 44px;
      clip-path: path('M 0,0 C 22,0 22,44 44,44 L 0,44 Z');
    }
  /* 边框-END */
    .card-tag, .card-tag:before ,.card-tag:after{
      user-select: none;
      transition: background .5s;
      cursor: pointer;
    }
    .selected-tag .card-tag{
      background: #FFF;
    }
    .selected-tag .card-tag:before{
      background: #FFF;
    }
    .selected-tag .card-tag:after{
      background: #FFF;
    }
    .card-tag{
      width: 86px;
      height: 37px;
      font-size: 13px;
      font-weight: 400;
      margin: 1px auto;
      position: relative;
      text-align: center;
      line-height: 37px;
      background: #E7EAF1;
    }
    .card-tag:before{
      content:'';
      position: absolute;
      top: 0;
      height: 100%;
      z-index: 2;
      background: #E7EAF1;
      left: -42.9px;
      width: 43px;
      clip-path: path('M 43,0 C 21.5,0 21.5,43 0,43 L 43,43 Z');
    }
    .card-tag:after{
      content:'';
      position: absolute;
      top: 0;
      height: 100%;
      z-index: 2;
      background: #E7EAF1;
      right: -42.9px;
      width: 43px;
      clip-path: path('M 0,0 C 21.5,0 21.5,43 43,43 L 0,43 Z');
    }
</style>